import { useBreakpointValue } from '@genial/utils';
import React from 'react';
import { Dimensions } from 'react-native';

import { RecentSameFileModalView } from './shared/RecentSameFileModalView';
import { RecentSameFileModalProps } from './types';

export type { RecentSameFileModalProps } from './types';

export const RecentSameFileModal: React.FC<RecentSameFileModalProps> = (props) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    const { height } = Dimensions.get('window');

    return (
      <RecentSameFileModalView
        {...props}
        showPeriodLabel={false}
        contentMaxHeight={height * 0.75}
        contentMaxWidth="full"
        contentMarginBottom={0}
        contentMarginTop="auto"
      />
    );
  }

  return (
    <RecentSameFileModalView
      {...props}
      showPeriodLabel
      contentMaxHeight="410px"
      contentMaxWidth="640px"
      contentMarginBottom="none"
      contentMarginTop={0}
    />
  );
};
